import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('peppermint_pipeworks', {
  cherry: 'peppermint_swirl',
  lemon: 'candy_cane',
  orange: 'mint_drop',
  bell: 'candy_pipe',
  star: 'peppermint_star',
  seven: 'pressure_gauge',
  gem: 'icemint_crystal',
  scatter: 'snow_globe',
  money: 'pipeworks_vault',
});

/** Peppermint Pipeworks — GENERATED by scaffoldSlot from
 *  content/slots/peppermint_pipeworks.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const PEPPERMINT_PIPEWORKS_THEME: Theme = {
  id: 'peppermint_pipeworks',
  name: 'Peppermint Pipeworks',
  palette: {
    accent: 0xff4d4d,
    secondary: 0x6fe3c4,
    warm: 0xeaf7ff,
    frameFill: 0x0e2630,
    bgGradientTop: 0x123040,
    bgGradientBottom: 0x07151c,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Peppermint Swirl', glyph: '🍬', tint: 0xff4d4d, weight: 5, textureAlias: 'peppermint_pipeworks:cherry',
        winVideoAlias: 'peppermint_pipeworks:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Candy Cane', glyph: '🍭', tint: 0xff4d4d, weight: 5, textureAlias: 'peppermint_pipeworks:lemon',
        winVideoAlias: 'peppermint_pipeworks:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Mint Drop', glyph: '🌿', tint: 0x6fe3c4, weight: 4, textureAlias: 'peppermint_pipeworks:orange',
        winVideoAlias: 'peppermint_pipeworks:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Candy-Cane Pipe', glyph: '🪈', tint: 0xff4d4d, weight: 3, textureAlias: 'peppermint_pipeworks:bell',
        winVideoAlias: 'peppermint_pipeworks:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Peppermint Star', glyph: '⭐', tint: 0xff4d4d, weight: 2, textureAlias: 'peppermint_pipeworks:star',
        winVideoAlias: 'peppermint_pipeworks:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Pressure Gauge', glyph: '🌡️', tint: 0xeaf7ff, weight: 2, textureAlias: 'peppermint_pipeworks:seven',
        winVideoAlias: 'peppermint_pipeworks:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Icemint Crystal', glyph: '💎', tint: 0x6fe3c4, weight: 2.5, textureAlias: 'peppermint_pipeworks:gem',
        winVideoAlias: 'peppermint_pipeworks:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Peppermint Snow Globe', glyph: '❄️', tint: 0xeaf7ff, weight: 0.5, textureAlias: 'peppermint_pipeworks:scatter',
        winVideoAlias: 'peppermint_pipeworks:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Pipeworks Vault', glyph: '🪙', tint: 0xff4d4d, weight: 1, textureAlias: 'peppermint_pipeworks:money',
        winVideoAlias: 'peppermint_pipeworks:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x0e2630, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xff4d4d, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xeaf7ff, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x0e2630, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x6fe3c4, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xff4d4d, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xeaf7ff, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x0e2630, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xeaf7ff, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xff4d4d, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xeaf7ff, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xeaf7ff, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'peppermint_pipeworks:bg', path: 'environment/peppermint_pipeworks.png' },
      columnBackground: { alias: 'peppermint_pipeworks:column_bg', path: 'reel/peppermint_pipeworks_column_bg.png' },
      border: { alias: 'peppermint_pipeworks:border', path: 'brand/border_candy.png' },
    },
  },
};
